import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./ResponsesView.scss";
import ResponseItem from "../ResponseItem";
import ResponseItemV2 from "./ResponseItemV2";
import OldResponseItem from "./ResponseItem";
import classNames from "classnames";
class ResponsesView extends PureComponent {
  render = () => {
    const {
      value,
      isToddlePlay,
      onMediaClick,
      userInfo,
      onEditClickFromViewMode,
      fieldId,
      showResponseEditButton,
      isSinglePageAndNewUnitView,
    } = this.props;
    const containerClass = classNames(classes.feedContainer, {
      [classes.feedContainerListView]: isToddlePlay,
      [classes.feedContainerSinglePage]: isSinglePageAndNewUnitView,
    });
    return (
      <div className={containerClass}>
        {_.map(value, response => {
          return isToddlePlay ? (
            <ResponseItem
              response={response}
              key={response.id}
              mode="view"
              onMediaClick={onMediaClick}
              userInfo={userInfo}
              onEditClickFromViewMode={onEditClickFromViewMode}
              fieldId={fieldId}
              showResponseEditButton={showResponseEditButton}
            />
          ) : isSinglePageAndNewUnitView ? (
            <ResponseItemV2
              item={response}
              key={response.id}
              onMediaClick={onMediaClick}
              isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
            />
          ) : (
            <OldResponseItem item={response} key={response.id} />
          );
        })}
      </div>
    );
  };
}

export default ResponsesView;
